import { render, staticRenderFns } from "./StepperSubStep.vue?vue&type=template&id=4c0a06b9&"
import script from "./StepperSubStep.vue?vue&type=script&lang=ts&"
export * from "./StepperSubStep.vue?vue&type=script&lang=ts&"
import style0 from "./StepperSubStep.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports